<template>
  <div
    v-if="iconClasses || statuses.isLoading "
    v-ripple="statuses.isFail"
    data-qa="status_icon"
    :data-qa-status="props.status"
    class="status-icon rounded-circle d-flex align-center justify-center bg-gray-0"
    :class="{
      'cursor-pointer': statuses.isFail,
    }"
    @click="statuses.isFail ? emit('click') : null"
  >
    <v-progress-circular
      v-if="statuses.isLoading"
      width="2"
      color="primary"
      size="20"
      :value="progressValue"
      :indeterminate="progressValue === undefined || Number(progressValue) >= 100"
    />
    <span
      v-else
      :class="iconClasses"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { Status } from 'src/components/pages/appointment/uslugi/new/components/ServiceAppointmentForm/components/AttachedFiles/types'
import { FILE_TYPES, MIME_TYPES } from 'www/constants'

const props = defineProps<{
  status: Status
  fileMimeType?: string
  progressValue?: number | string
}>()

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()

const statuses = computed(() => ({
  isSuccess: props.status === 'success',
  isFail: props.status === 'fail',
  isLoading: props.status === 'loading',
}))

const iconClasses = computed(() => {
  if (statuses.value.isSuccess) {
    switch (props.fileMimeType) {
      case MIME_TYPES.pdf:
      case FILE_TYPES.pdf:
        return 'ui-icon-file text-error--text'
      default:
        return ''
    }
  }

  if (statuses.value.isFail) {
    return 'ui-icon-reset primary--text'
  }

  return ''
})
</script>

<style lang="scss" scoped>
.status-icon {
  width: 36px;
  height: 36px;
}
</style>
